export enum FilterSelector {
  AllShipments = 'AllShipments',
  Customers = 'Customers',
  AllProviders = 'AllProviders'
}
